import { useEffect } from "react";

let bodyScrollLockCount = 0;
let originalBodyOverflow = "";
let originalBodyPaddingRight = "";

export const MODAL_ANIMATION_CSS = `
  @keyframes modal-overlay-enter {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes modal-panel-enter {
    from {
      opacity: 0;
      transform: translateY(14px) scale(0.985);
    }
    to {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`;

export const MODAL_OVERLAY_STYLE = {
  animation: "modal-overlay-enter 180ms ease-out",
} as const;

export const MODAL_PANEL_STYLE = {
  animation: "modal-panel-enter 220ms cubic-bezier(0.22, 1, 0.36, 1)",
} as const;

export const useBodyScrollLock = (isLocked: boolean) => {
  useEffect(() => {
    if (!isLocked || typeof document === "undefined") return;

    const { body, documentElement } = document;

    if (bodyScrollLockCount === 0) {
      originalBodyOverflow = body.style.overflow;
      originalBodyPaddingRight = body.style.paddingRight;

      const scrollbarWidth = window.innerWidth - documentElement.clientWidth;
      body.style.overflow = "hidden";

      if (scrollbarWidth > 0) {
        body.style.paddingRight = `${scrollbarWidth}px`;
      }
    }

    bodyScrollLockCount += 1;

    return () => {
      bodyScrollLockCount = Math.max(0, bodyScrollLockCount - 1);

      if (bodyScrollLockCount === 0) {
        body.style.overflow = originalBodyOverflow;
        body.style.paddingRight = originalBodyPaddingRight;
      }
    };
  }, [isLocked]);
};
